import React, { Component } from 'react';
import { connect } from 'react-redux';
import Paper from 'material-ui/Paper';
import NavigationMenu from 'material-ui/svg-icons/navigation/menu';
import NavigationChevronLeft from 'material-ui/svg-icons/navigation/chevron-left';
import NavigationChevronRight from 'material-ui/svg-icons/navigation/chevron-right';

import './Calendar.css';

const mapStateToProps = (state) => {
  return {
    fonts: state.fonts,
    fontSize: state.fontSize,
  }
}

class Calendar extends Component {
  render() {

    const {
      fonts,
    } = this.props;


    const {
      primary,
      secondary
    } = fonts;

    const styles = {
      primaryFont: {
        fontFamily: primary.name
      },
      secondaryFont: {
        fontFamily: secondary.name
      },
    }

    return (
      <Paper
        zDepth={1}
        className="phone-wrapper">
        <div style={styles.primaryFont}
          className="calendar-header">
          <div className="hamburger-menu">
            <NavigationMenu className="hamburger-menu-icon" />
          </div>
          <div className="calendar-year">
            2017
          </div>
          <div className="calendar-month">
            April
          </div>
          <div className="calendar-month-selectors">
            <NavigationChevronLeft className="left-month-selector" />
            <NavigationChevronRight className="right-month-selector" />
          </div>
          <div className="clear"></div>
        </div>
        <div className="day-names">
          <table
            style={styles.secondaryFont}
            className="day-names-table">
            <tbody>
              <tr>
                <td>Mon</td>
                <td>Tue</td>
                <td>Wed</td>
                <td>Thu</td>
                <td>Fri</td>
                <td>Sat</td>
                <td>Sun</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="calendar-table-container">
          <table
            style={styles.secondaryFont}
            className="calendar-table">
            <tbody>
              <tr>
                <td className="gray-day">27</td>
                <td className="gray-day">28</td>
                <td className="gray-day">29</td>
                <td className="gray-day">30</td>
                <td className="gray-day">31</td>
                <td>1</td>
                <td>2</td>
              </tr>
              <tr>
                <td>3</td>
                <td>4</td>
                <td>5</td>
                <td>6</td>
                <td>7</td>
                <td>8</td>
                <td>9</td>
              </tr>
              <tr>
                <td>10</td>
                <td>11</td>
                <td>12</td>
                <td>
                  <span className="pink-day">13</span>
                </td>
                <td>14</td>
                <td>15</td>
                <td>16</td>
              </tr>
              <tr>
                <td>17</td>
                <td>18</td>
                <td>
                  <span className="purple-day">19</span>
                </td>
                <td>20</td>
                <td>21</td>
                <td>22</td>
                <td className="circle-day">23</td>
              </tr>
              <tr>
                <td>24</td>
                <td>25</td>
                <td>26</td>
                <td>27</td>
                <td>
                  <span className="green-day">28</span>
                </td>
                <td>29</td>
                <td>30</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="calendar-events-container">
          <div className="event-line">
            <hr className="pink-hr" />
          </div>
          <div className="event-name-text"
            style={styles.secondaryFont}>
            Kenny's birthday
          </div>
        </div>
        <div className="calendar-events-container">
          <div className="event-line">
            <hr className="purple-hr" />
          </div>
          <div className="event-name-text"
            style={styles.secondaryFont}>
            Eric:Eddie 1:1 Recurring
          </div>
        </div>
        <div className="calendar-events-container">
          <div className="event-line">
            <hr className="green-hr" />
          </div>
          <div className="event-name-text"
            style={styles.secondaryFont}>
            Lake Tahoe offsite
          </div>
        </div>
      </Paper>
    )
  }
}

export default Calendar = connect(mapStateToProps, undefined)(Calendar);



// WEBPACK FOOTER //
// ./src/components/generator/elements/Calendar.jsx